import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import VideoAccordion from "../components/VideoAccordion";
import QuizCard from "../components/QuizCard";
import styles from "./CourseDetails.module.css";
import { FiInstagram, FiMail } from "react-icons/fi";

export default function CourseDetails() {
  const { id } = useParams();
  const { user } = useContext(AuthContext);

  const [course, setCourse] = useState(null);
  const [videos, setVideos] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const [access, setAccess] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!user) return;

    fetch(`${process.env.REACT_APP_API_URL}/api/courses/${id}/access`, {
      credentials: 'include'
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(j => setAccess(!!j.access))
      .catch(console.error);

    fetch(`${process.env.REACT_APP_API_URL}/api/courses/${id}`, {
      credentials: 'include'
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(setCourse)
      .catch(err => {
        console.error("Error cargando curso:", err);
        setCourse(null);
      });

    fetch(`${process.env.REACT_APP_API_URL}/api/courses/${id}/videos`, {
      credentials: 'include'
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(data => setVideos(Array.isArray(data) ? data : []))
      .catch(err => {
        console.error("Error cargando videos:", err);
        setVideos([]);
      });

    fetch(`${process.env.REACT_APP_API_URL}/api/courses/${id}/quizzes`, {
      credentials: 'include'
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(data => setQuizzes(Array.isArray(data) ? data : []))
      .catch(err => {
        console.error("Error cargando quizzes:", err);
        setQuizzes([]);
      });

  }, [id, user]);

  if (course === null) return <p>Cargando curso…</p>;

  const visibleIds = access
    ? videos.map(v => v.id)
    : course.previewVideoIds || [];

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <h1>{course.title}</h1>
        <p>{course.description}</p>
      </header>

      <section className={styles.accordionList}>
        {videos.map(v => {
          const relatedQuiz = quizzes.find(q => q.videoId === v.id);
          const isVisible = visibleIds.includes(v.id);

          return (
            <div key={v.id}>
              <VideoAccordion
                video={v}
                quiz={access ? relatedQuiz : null}
                disabled={!isVisible}
              />
              {access && relatedQuiz && (
                <div className={styles.quizWrapper}>
                  <QuizCard quiz={relatedQuiz} />
                </div>
              )}
            </div>
          );
        })}
      </section>

      {!access && (
        <>
          <button className={styles.buyBtn} onClick={() => setShowModal(true)}>
            Obtener acceso completo
          </button>
          {showModal && (
            <div className={styles.modalOverlay}>
              <div className={styles.modal}>
                <button className={styles.closeBtn} onClick={() => setShowModal(false)}>×</button>
                <h2>¿Querés acceder al curso completo?</h2>
                <p>Contactanos por Instagram o por correo:</p>
                <div className={styles.contactLinks}>
                  <a
                    href="https://www.instagram.com/medicina_total1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.contactLink}
                  >
                    <FiInstagram size={20} /> <span>@medicina_total1</span>
                  </a>
                  <a
                    href="mailto:medicinatotal91@gmail.com"
                    className={styles.contactLink}
                  >
                    <FiMail size={20} /> <span>medicinatotal91@gmail.com</span>
                  </a>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
